import { render, staticRenderFns } from "./ViolationRejectButtons.vue?vue&type=template&id=077e66e2&"
import script from "./ViolationRejectButtons.vue?vue&type=script&lang=ts&"
export * from "./ViolationRejectButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports